export default function CommercialContractorsFAQ() {
  const faqs = [
    {
      question: 'How much does commercial construction cost in El Paso?',
      answer: 'Commercial construction costs vary widely by project type. Office buildings cost $150-$300 per square foot, retail spaces $100-$200, warehouses $60-$120, and medical facilities $250-$500+. Factors affecting cost include building complexity, finishes, site conditions, and systems requirements. Tenant improvements typically cost $50-$150 per square foot. Get detailed estimates from multiple contractors to compare pricing and value for your specific project.'
    },
    {
      question: 'How long does a commercial construction project take?',
      answer: 'Timeline depends on project size and complexity. Small tenant improvements take 2-4 months, retail build-outs 4-8 months, warehouses 6-12 months, and multi-story office buildings 12-24 months. Factors affecting timeline include design complexity, permitting, weather, material availability, and inspection schedules. Experienced contractors provide realistic schedules with milestone dates and strategies for staying on track.'
    },
    {
      question: 'What permits are required for commercial construction in El Paso?',
      answer: 'Commercial projects require building permits from the City of El Paso, and often additional permits for electrical, plumbing, mechanical, and fire protection systems. Larger projects need plan review and approval before permits are issued. Some projects require special use permits or zoning variances. Professional contractors handle all permitting, coordinate inspections, and ensure compliance with commercial building codes throughout construction.'
    },
    {
      question: 'Should I hire a general contractor or construction manager?',
      answer: 'General contractors provide a single point of responsibility for design-bid-build projects with fixed pricing. Construction managers work on a fee basis, providing oversight while you contract directly with trades. For most commercial projects under $5 million, general contractors offer better value and accountability. Larger or more complex projects may benefit from construction management. Discuss both approaches with contractors to determine the best fit.'
    },
    {
      question: 'How do I ensure my commercial project stays on budget?',
      answer: 'Start with detailed plans and specifications to minimize changes during construction. Get comprehensive bids from qualified contractors. Establish a contingency fund (10-15%) for unforeseen conditions. Use formal change order processes for any modifications. Require regular budget updates and payment applications tied to completed work. Experienced contractors provide transparent financial management and communicate about potential cost impacts before they occur.'
    },
    {
      question: 'What should I know about commercial construction financing?',
      answer: 'Commercial construction loans differ from residential financing with shorter terms, higher rates, and stricter requirements. Lenders typically require 20-30% down payment, detailed project plans, contractor qualifications, and proof of tenant commitments or pre-leasing. Funds are disbursed in draws tied to construction milestones. Work with commercial lenders experienced in construction financing and ensure your contractor understands draw schedules and lender requirements.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about commercial construction projects in El Paso answered by local experts.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className="ri-arrow-down-s-line text-2xl text-gray-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-6">
                <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 text-center bg-teal-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Still Have Questions?
          </h3>
          <p className="text-gray-700 mb-6">
            Connect with experienced commercial contractors who can provide personalized answers for your specific project needs.
          </p>
          <a href="#directory" className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
            Contact a Contractor
          </a>
        </div>
      </div>
    </section>
  );
}
